import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import Button from 'v3/common/components/Button';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const FlatTrade: FC<BrokerSpecificComponentsProps> = () => {
  return (
    <div className="maintainer__container">
      <i className="fa-regular fa-circle-info" />
      <p>
        <strong>Flatrade</strong> is moved to <strong>Qubit</strong>, So login from here will redirect you to
        Qubit
      </p>
      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button onClick={() => (window.location.href = 'https://qubit.flattrade.in/')}>
          Login Via Qubit
        </Button>
      </PortalToTarget>
    </div>
  );
};

export default FlatTrade;
